import { guards } from '@shared/helpers/typeguards.helpers';
import { throwValidationErrors } from './validation.helpers';
import { GenericValidationError, ValidationResult } from './validation.models';

export const isValidOrganizations = (
  organizations?: string[],
): ValidationResult => {
  if (!Array.isArray(organizations) || organizations.length !== 1) {
    return new GenericValidationError(
      'Organizations must be an array of exactly one organization', // We only support one organization per item today
    );
  }

  return true;
};

export const isValidOwnerAndOrganizations = <
  T extends { owner?: string; organizations?: string[] },
>(
  data: T,
): ValidationResult => {
  const { owner, organizations } = data;

  if (!guards.is.nonEmptyString(owner)) {
    return new GenericValidationError('Owner must be a non empty string');
  }
  return isValidOrganizations(organizations);
};

export const validateOwnerAndOrganizations = <
  T extends { owner: string; organizations: string[] },
>(
  data: T,
): T => {
  const errors = isValidOwnerAndOrganizations(data);
  if (errors !== true) {
    throwValidationErrors(errors);
  }
  return data;
};
